import { BeltColorEnum } from 'src/shared/enum/belt-color.enum'
import { IGrade } from 'src/shared/interface/model.interface'

export const defaultGrades: Array<IGrade> = [
  {
    isDan: false,
    isKyu: true,
    beltColor: BeltColorEnum.YELLOW,
    gradeLevel: 8,
    gradeOrder: 1,
    programs: [
      {
        order: 1,
        label: 'BO HOJOUNDO ICHI',
        comment: '1ère série de bo (du haut vers le bas)'
      }, {
        order: 2,
        label: 'KUMI BO ICHI',
        comment: '1ère série de bo en application (toucher = échec)'
      }, {
        order: 3,
        label: 'BO KIHON ICHI',
        comment: '1er kata de bo (commence par naname, parades esquivées)'
      }
    ]
  }, {
    isDan: false,
    isKyu: true,
    beltColor: BeltColorEnum.ORANGE,
    gradeLevel: 7,
    gradeOrder: 1,
    programs: [
      {
        order: 1,
        label: 'BO HOJOUNDO NI',
        comment: '2ème série de bo'
      }, {
        order: 2,
        label: 'KUMI BO NI',
        comment: '2ème série de bo en application (toucher = échec)'
      }, {
        order: 3,
        label: 'BO KIHON NI',
        comment: '2ème kata de bo (jetés de sable, parades rentrantes sauf basse debout)'
      }, {
        order: 4,
        label: 'BO KIHON ICHI KUMIWAZA',
        comment: '1er kata de bo en application (toucher = échec)'
      }
    ]
  }, {
    isDan: false,
    isKyu: true,
    beltColor: BeltColorEnum.GREEN,
    gradeLevel: 6,
    gradeOrder: 1,
    programs: [
      {
        order: 1,
        label: 'SAI HOJOUNDO ICHI',
        comment: '1ère série de saïs (tsuki, double, 3 parades)'
      }, {
        order: 2,
        label: 'SAI KIHON IPPON KUMITE',
        comment: '5 attaques conventionnelles de saïs (toucher = échec), annoncées. Départ en yoï'
      }, {
        order: 3,
        label: 'SAI KIHON ICHI',
        comment: '1er kata de saïs (parer, piquer, parades esquivées)'
      }, {
        order: 4,
        label: 'BO KIHON NI KUMIWAZA',
        comment: '2ème kata de bo en application (toucher = échec)'
      }
    ]
  }, {
    isDan: false,
    isKyu: true,
    beltColor: BeltColorEnum.BLUE,
    gradeLevel: 5,
    gradeOrder: 1,
    programs: [
      {
        order: 1,
        label: 'TONFA HOJOUNDO ICHI',
        comment: '1ère série de tonfas (comme les saïs, gedan ouvert zenkutsu)'
      }, {
        order: 2,
        label: 'TONFA KIHON IPPON KUMITE',
        comment: '5 attaques conventionnelles de tonfas (toucher = échec)'
      }, {
        order: 3,
        label: 'TONFA KIHON ICHI',
        comment: '1er kata de tonfas (change après 3ème gedan, parades esquivées)'
      }, {
        order: 4,
        label: 'SAI KIHON ICHI KUMIWAZA',
        comment: '1er kata de saïs en application(toucher = échec)'
      }
    ]
  }, {
    isDan: false,
    isKyu: true,
    beltColor: BeltColorEnum.BLUE,
    gradeLevel: 4,
    gradeOrder: 2,
    programs: [
      {
        order: 1,
        label: 'NUNCHAKU HOJOUNDO ICHI',
        comment: '1ère série de nunchakus. (10 mouvements : Bloc essuie-glace, pic, corde + dbl, bloc tête, bloc côté, bloc naname corde, pic à l\'envers, frappe tendu, bloc ramassé devant + entoure, bloc enroulé épaule)'
      }, {
        order: 2,
        label: 'KUMI NUNCHAKU ICHI',
        comment: '1ère série de nunchakus en application (toucher = échec), (7 mouvements au lieu de 10, dont 2 sans riposte)'
      }, {
        order: 3,
        label: 'NUNCHAKU KIHON IPPON KUMITE',
        comment: '5 attaques conventionnelles de nunchakus (toucher = échec)'
      }, {
        order: 4,
        label: 'NUNCHAKU DAÏ ICHI',
        comment: '1er kata de nunchakus'
      }, {
        order: 5,
        label: 'TONFA KIHON ICHI KUMIWAZA',
        comment: '1er kata de tonfas en application (toucher = échec)'
      }
    ]
  }, {
    isDan: false,
    isKyu: true,
    beltColor: BeltColorEnum.BROWN,
    gradeLevel: 3,
    gradeOrder: 1,
    programs: [
      {
        order: 1,
        label: 'BO HOJOUNDO SAN',
        comment: '3ème série de bo (basée sur les 3 katas supérieurs)'
      }, {
        order: 2,
        label: 'KUMI BO SAN',
        comment: '3ème série de bo en application'
      }, {
        order: 3,
        label: 'BO SUSHINOKON',
        comment: '1er kata supérieur de bo (Grand/Petit. Paré bas direct. Gorenda)'
      }, {
        order: 4,
        label: 'SUSHINOKON KUMIWAZA',
        comment: '1er kata supérieur de bo en application'
      }, {
        order: 5,
        label: 'BO KIHON ICHI OYO',
        comment: '1er kata de bo en application, façon combat'
      }
    ]
  }, {
    isDan: false,
    isKyu: true,
    beltColor: BeltColorEnum.BROWN,
    gradeLevel: 2,
    gradeOrder: 2,
    programs: [
      {
        order: 1,
        label: 'SAI HOJOUNDO NI',
        comment: '2ème série de saïs'
      }, {
        order: 2,
        label: 'SAI DAÏ ICHI',
        comment: '1er kata supérieur de saïs'
      }, {
        order: 3,
        label: 'SAI DAÏ ICHI KUMIWAZA',
        comment: '1er kata supérieur de saïs en application'
      }, {
        order: 4,
        label: 'SAI KIHON ICHI OYO',
        comment: '1er kata de saïs en application, façon combat'
      }
    ]
  }, {
    isDan: false,
    isKyu: true,
    beltColor: BeltColorEnum.BROWN,
    gradeLevel: 1,
    gradeOrder: 3,
    programs: [
      {
        order: 1,
        label: 'TONFA HOJOUNDO NI',
        comment: '2ème série de tonfas '
      }, {
        order: 2,
        label: 'TONFA DAÏ ICHI',
        comment: '1er kata supérieur de tonfas'
      }, {
        order: 3,
        label: 'TONFA DAÏ ICHI KUMIWAZA',
        comment: '1er kata supérieur de tonfas en application'
      }, {
        order: 4,
        label: 'TONFA KIHON ICHI OYO',
        comment: '1er kata de tonfas en application, façon combat'
      }
    ]
  }, {
    isDan: true,
    isKyu: false,
    beltColor: BeltColorEnum.BLACK,
    gradeLevel: 1,
    gradeOrder: 1,
    programs: [
      {
        order: 1,
        label: 'NUNCHAKU HOJOUNDO NI',
        comment: '2ème série de nunchakus (la 1ère avec un mouvement en plus à chaque fois)'
      }, {
        order: 2,
        label: 'NUNCHAKU DAÏ NI',
        comment: '2ème kata de nunchakus'
      }, {
        order: 3,
        label: 'KUMITE',
        comment: 'Combat souple non arbitré, arme libre. Peu importe qui gagne, on veut juste voir le comportement au combat.'
      }, {
        order: 4,
        label: 'CHOUNNOKON',
        comment: '2ème kata supérieur de bo'
      }, {
        order: 5,
        label: 'CHOUNNOKON KUMIWAZA',
        comment: '2ème kata supérieur de bo en application'
      }, {
        order: 6,
        label: 'SAI HOJOUNDO SAN',
        comment: '3ème série de saïs'
      }, {
        order: 7,
        label: 'SAI DAÏ NI',
        comment: '2ème kata supérieur de saïs'
      }
    ]
  }
]
